export default "__VITE_ASSET__DaAlsIx7__"